import { render } from "./app-logo-symbol.vue?vue&type=template&id=8176d20a"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-symbol.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8176d20a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8176d20a', __exports__)) {
    console.log('reload')
    api.reload('8176d20a', __exports__)
  }
  
  module.hot.accept("./app-logo-symbol.vue?vue&type=template&id=8176d20a", () => {
    console.log('re-render')
    api.rerender('8176d20a', render)
  })

}


export default __exports__